const extractBookValues = (book) => {
  if (!book) return null;

  const { annotation, author, genre, narrator, title, isPublished } = book;

  return { annotation, author, genre, narrator, title, isPublished };
};

export default extractBookValues;
